import request from "@/components/common/utils/request.js"

export function api_submitSearch(data) {
	return request({
		url: '/api/keywod/submitSearch',
		method: 'post',
		data : data
	})
}

export function api_listByKeyword(data) {
	return request({
		url: '/api/keywod/listByKeyword',
		method: 'get',
		params : data
	})
}

export function api_listForChart(data) {
	return request({
		url: '/api/keywod/listForChart',
		method: 'get',
		params : data
	})
}

export function api_listByAsinId(data) {
	return request({
		url: '/api/keywod/listByAsinId',
		method: 'get',
		params : data
	})
}

export function api_delKeywordRanking(list){
	return request({
		url: '/api/keywod/del',
		method: 'post',
		data : list
	})
}

export function api_keyword_keywordsRelatedList(data){
	return request({
		url: '/api/keywod/keywordsRelatedList',
		method: 'get',
		params : data
	})
}

export function api_keyword_getCheckedKeywordsListByAsinId(list,asinId){
	return request({
		url: '/api/keywod/getCheckedKeywordsListByAsinId',
		method: 'post',
		data : {
			keywords : list,
			asinId : asinId
		} 
	})
}

export function api_keyword_getKeywordSearchTrend(id){
	return request({
		url: '/api/keywod/getKeywordSearchTrend',
		method: 'get',
		params : {
			keywordId : id
		}
	})
}

export function api_keyword_updateKeywordConfig(arr){
	return request({
		url: '/api/keywod/updateKeywordConfig',
		method: 'post',
		data : arr
	})
}

export function api_keyword_keywordSearchPage(id){
	return request({
		url: '/api/keywod/keywordSearchPage',
		method: 'get',
		params : {
			id : id
		}
	})
}

export function api_keyword_keywordTrackingExpirationTimeDelay(ids,num){
	return request({
		url: '/api/keywod/keywordTrackingExpirationTimeDelay',
		method: 'get',
		params : {
			keywordIds : ids,
			amount : num
		}
	})
}


